import React from 'react';

interface IUsePersistOnLocalStorageProps<T> {
	key: string;
	data: T;
	notPersistWhen?: boolean;
}

export default function usePersistOnLocalStorage<
	T extends object | Array<any>
>({
	key,
	data,
	notPersistWhen,
}: IUsePersistOnLocalStorageProps<T>): {
		getData: () => T | null;
		getTimestamp: () => number | null;
		removeData: () => void;
	} {
	React.useEffect(() => {
		if (!!data && !notPersistWhen) {
			localStorage.setItem(
				key,
				JSON.stringify({ payload: data, timestamp: Date.now(), })
			);
		}
	}, [ data, ]);

	const getData = (): T | null => {
		try {
			const data = localStorage.getItem(key);
			if (!data) return null;
			const parsedData = JSON.parse(data);
			return parsedData.payload as T;
		} catch (error) {
			return null;
		}
	};
	const getTimestamp = (): number | null => {
		try {
			const data = localStorage.getItem(key);
			if (!data) return null;
			const parsedData = JSON.parse(data);
			return parsedData.timestamp as number;
		} catch (error) {
			return null;
		}
	};
	const removeData = () => {
		localStorage.removeItem(key);
	};

	return { getData, getTimestamp, removeData, };
}
